import { useQuery } from '@tanstack/react-query';
import { membershipService } from '@/data/membership';

/**
 * React Query hook for remaining founder spots
 * Implements aggressive caching per Engineering Playbook
 */
export const useRemainingSpots = () => {
  return useQuery({
    queryKey: ['founder-spots'],
    queryFn: () => membershipService.getRemainingSpots(),
    staleTime: 2 * 60 * 1000,      // 2 min (spots change rarely)
    gcTime: 10 * 60 * 1000,        // 10 min
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
